import React from 'react';

export const SOURCE_COMPONENT_META = {
  openmetadata: {
    bg: 'var(--purple-50)',
    label: 'OpenMetadata',
    repo: 'https://github.com/open-metadata/OpenMetadata',
    icon: (size = 13) => (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <ellipse cx="12" cy="5.6" rx="7" ry="2.6" stroke="var(--purple-600)" />
        <path d="M5 5.6v12.8c0 1.44 3.13 2.6 7 2.6s7-1.16 7-2.6V5.6" stroke="var(--purple-600)" />
        <path d="M8.4 17V11.4l3.6 3.1 3.6-3.1V17" stroke="var(--purple-500)" />
      </svg>
    ),
  },
  'ai-platform': {
    bg: 'var(--purple-50)',
    label: 'AI Platform',
    repo: 'https://github.com/open-metadata/collate-ai',
    icon: (size = 13) => (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="var(--purple-700)" stroke="none">
        <path d="m12 3 1.5 5L19 9.5 14 11l-2 5-2-5-5-1.5L10 8z" />
      </svg>
    ),
  },
  collate: {
    bg: 'var(--blue-50)',
    label: 'Collate',
    repo: 'https://github.com/open-metadata/openmetadata-collate',
    icon: (size = 13) => (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3.5 7 12 11.2 20.5 7" stroke="#00C2FF" />
        <path d="M3.5 12 12 16.2 20.5 12" stroke="var(--blue-500)" />
        <path d="M3.5 17 12 21.2 20.5 17" stroke="var(--blue-600)" />
      </svg>
    ),
  },
  'hybrid-runner': {
    bg: 'var(--blue-50)',
    label: 'Hybrid Runner',
    repo: 'https://github.com/open-metadata/openmetadata-hybrid-runner',
    icon: (size = 13) => (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="var(--blue-700)" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 4h20v6H2zM2 14h20v6H2zM6 7h.01M6 17h.01" />
      </svg>
    ),
  },
  construct: {
    bg: 'var(--blue-50)',
    label: 'Construct',
    repo: 'https://github.com/open-metadata/construct',
    icon: (size = 13) => (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="var(--blue-600)" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 8h7V3M14 3v7h7M21 16h-7v5M10 21v-5H3" />
      </svg>
    ),
  },
  'openmetadata-helm-charts': {
    bg: 'var(--teal-50, var(--blue-50))',
    label: 'OpenMetadata Helm Charts',
    repo: 'https://github.com/open-metadata/openmetadata-helm-charts',
    icon: (size = 13) => (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="var(--blue-700)" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2 3 7v10l9 5 9-5V7l-9-5zM3 7l9 5m0 0 9-5m-9 5v10" />
      </svg>
    ),
  },
  'hybrid-helm': {
    bg: 'var(--teal-50, var(--blue-50))',
    label: 'Hybrid Runner Helm Chart',
    repo: 'https://github.com/open-metadata/hybrid-ingestion-runner-helm-chart',
    icon: (size = 13) => (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="var(--blue-700)" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2 3 7v10l9 5 9-5V7l-9-5zM3 7l9 5m0 0 9-5m-9 5v10" />
      </svg>
    ),
  },
  'ai-proxy-helm': {
    bg: 'var(--teal-50, var(--blue-50))',
    label: 'AI Proxy Helm Chart',
    repo: 'https://github.com/open-metadata/collate-ai-proxy-helm-chart',
    icon: (size = 13) => (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="var(--blue-700)" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2 3 7v10l9 5 9-5V7l-9-5zM3 7l9 5m0 0 9-5m-9 5v10" />
      </svg>
    ),
  },
  'terraform-aws': {
    bg: 'var(--purple-50)',
    label: 'Terraform AWS Module',
    repo: 'https://github.com/open-metadata/terraform-aws-openmetadata',
    icon: (size = 13) => (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="var(--purple-600)" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h6v6H4zM14 4h6v6h-6zM14 14h6v6h-6zM4 14h6v6H4z" />
      </svg>
    ),
  },
  'terraform-deploy': {
    bg: 'var(--purple-50)',
    label: 'Terraform Deployment',
    repo: 'https://github.com/open-metadata/openmetadata-deployment',
    icon: (size = 13) => (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="var(--purple-600)" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h6v6H4zM14 4h6v6h-6zM14 14h6v6h-6zM4 14h6v6H4z" />
      </svg>
    ),
  },
};

export function normalizeSourceComponentId(id) {
  return String(id || '').replace(/_/g, '-');
}

export function getSourceComponentMeta(id) {
  return SOURCE_COMPONENT_META[normalizeSourceComponentId(id)] || null;
}
